import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const BuildupHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=buildup-control`

  return (
    <Modal
      title={
        <div className='buildup-help-header'>
          <span className='buildup-help-header-title'>Build-up Control Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Build-up Control summary.pdf'>
          <Button type='primary' className='buildup-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal buildup-help-modal'
    >
      <div className='buildup-help-content'>
        <div className='buildup-help-card'>
          <div className='buildup-help-title'>Build-up Control</div>
          <p>
            The Build-up Control screen provides a view of all export shipments which are booked and/or assigned to departing flights. Data is displayed depending upon the work area tile selected. Shipments which are at risk of not meeting the connection time requirements can be identified and actioned upon by the user by using the recovery actions defined for this module.
          </p>
          <p>
            The Build-up Control module works together with the Flight Capacity Planning module to display the planned configuration and Cargo Payload defined for the flight by the DoD team. The Build-up Control uses the Build-up Area Mapping, Handling times, Recovery Actions and ULD Mapping as parameters from the System Parameters module.
          </p>
        </div>

        <div className='buildup-help-card'>
          <div className='buildup-help-title'>Conditions to Add</div>
          <p>
            By default, data is displayed on the Build-up Control screen in a 6 hour interval from current time. Flights which have some booking information or which have received a FSU/MAN assignment will be displayed.
          </p>
        </div>

        <div className='buildup-help-card'>
          <div className='buildup-help-title'>Conditions to Remove</div>
          <ul className='buildup-help-list'>
            <li>
              Flights are removed from the Build-up control screen once the time interval selected goes beyond the departure time of the flight.
            </li>
            <li>
              If the departed flight&apos;s departure time is within the time interval of the filters, the flight will still be displayed. Use the Hide Departed checkbox to remove the flight.
            </li>
          </ul>
        </div>

        <div className='buildup-help-card'>
          <div className='buildup-help-title'>Order by</div>
          <p>
            The flights displayed are ordered by the FPE- value in descending order. The list can be further filtered to show only Wide body(WB), only Narrow body(NB) or RFS only (Road Feeder Services). Flights which have been marked as priority by the DoD team will appear when the BU Prio checkbox is ticked.
          </p>
        </div>

        <div className='buildup-help-card'>
          <div className='buildup-help-title'>Comments</div>
          <ul className='buildup-help-list'>
            <li>
              <strong>AWB Status indicator :</strong> the colour indicator on an AWB level is driven by the Handling time remaining for the AWB. If the handling time remaining falls below the amber threshold set on the Handling times page, then the AWB status indicator will be <span className='buildup-text-amber'>amber</span>. However once the AWB is built-up into a ULD or cart - the AWB status indicator will be <span className='buildup-text-green'>green</span> regardless of the handling time remaining.
            </li>
            <li>
              AWBs which have <span className='buildup-text-grey'>grey</span> status indicator have not been received at the station. The data for these AWBs is fetched from the booking only, and the HCS has not received an incoming manifest or FOH/RCS message for export shipments.
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default BuildupHelpModal
